/**
 * Main entry point - DPS-ERP v3 Frontend
 * OP-2026-0129: Frontend Admin SaaS
 */
import { createApp } from 'vue'
import { createPinia } from 'pinia'

import App from './App.vue'
import router from './router'
import { useAuthStore } from './stores/auth'

// Bootstrap JS (precisa de Popper para dropdowns)
import 'bootstrap/dist/js/bootstrap.bundle.min.js'

// Bootstrap Icons
import 'bootstrap-icons/font/bootstrap-icons.css'

// Estilos customizados (importa Bootstrap SCSS)
import './assets/styles/main.scss'

// Criar app
const app = createApp(App)

// Pinia (state management)
const pinia = createPinia()
app.use(pinia)

// Inicializar auth store e restaurar sessão
const authStore = useAuthStore()
authStore.initAuthListener()

// Vue Router
app.use(router)

// Montar app
app.mount('#app')
